// extracted by mini-css-extract-plugin
export default {"row":"Forms_row__CwenD","savedCaseColumn":"Forms_savedCaseColumn__cdh6s"};